export enum TaskDialogType {
  NewTask = 'NewTask',
  ExistingTask = 'ExistingTask',
}